import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Tüm API isteklerine otomatik olarak withCredentials: true ekler
 * Bu interceptor, CORS cookie sorunlarını önlemek için kullanılır
 */
@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Sadece API istekleri için withCredentials ekle
    if (req.url.includes('api.pusulatatil.com') || req.url.includes('/api/')) {
      const credentialsReq = req.clone({
        withCredentials: true
      });
      
      return next.handle(credentialsReq);
    }
    
    return next.handle(req);
  }
}
